module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-sound_on@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-sound_on@2x.png
// module id = 657
// module chunks = 0